import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

/**
 * SPM-3405: returns whether the GenAI badge on AI-generated asset thumbnails should be shown.
 *
 * Defaults to `false` — the badge stays hidden until the flag is
 * explicitly enabled.
 */
function useShowGenAiBadge(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.SHOW_GEN_AI_BADGE, false);
}

export { useShowGenAiBadge };
